// extracted by mini-css-extract-plugin
module.exports = {"content":"MemoryNotFound_content__0mfRH","button":"MemoryNotFound_button__8ML9_"};